module.exports = __webpack_public_path__ + "img/icon-zoom-out.a2058194.svg";